module.exports = __webpack_public_path__ + "static/media/ministere_sante.e4382125.png";